import { useEffect, useMemo, useState } from "react";

import { SessionInterface, SocketEventType } from "@swivl-mono/types";
import { useNavigate, useParams } from "react-router-dom";
import { GetChannelFromParam } from "../../Helpers/Conversations/Conversations.Helper";
// import useSessionMessageData from "../../Hooks/useSessionMessageData";
import { useUrlState } from "../../Hooks/useUrlState";
import ModalModel from "../../Models/Modal/Modal.Model";
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import SocketEventsManager from "../../Models/SocketEvents/SocketEvents.Manager";
import { UsersModel } from "../../Models/Users/Users.Model";
import { UsersOnlineManager } from "../../Models/Users/UsersOnline.Manager";
import UserVarsModel from "../../Models/Variables/UserVars.Model";
import { HeaderAgentView } from "./Components/HeaderAgentView/HeaderAgentView";
import { StartShiftModal } from "./Components/StartShiftModal/StartShiftModal";
import UserDetails from "./DetailsColumn/UserDetails";
import { MembersOnlineSection } from "./MembersOnlineSection";
import { MultiChannelColumn } from "./MultiChannelColumn/MultiChannelColumn";
import { ConversationUserListColumn } from "./UserListColumn/Conversations.UserListColumn";
import { SMSCampaignButton } from "./Components/SMSCampaignButton/SMSCampaignButton";
import { Member } from "../../Models/Member/Member.Current";

export type EscalationStatus = "open" | "closed";

export enum ConversationUserListTabsStateType {
  Loading,
  Open,
  Closed,
}

function ConversationsView() {
  const { users, conversations, sessions } = UsersModel.useState((s) => s);
  const { userId } = useParams();
  const navigate = useNavigate();
  const selectedUserId = userId ? Number(userId) : undefined;
  const selectedUser = users ? users[selectedUserId || -1] : undefined;
  const { vars } = UserVarsModel.useState((s) => s);
  const { getSearchParam, setSearchParam } = useUrlState();
  const channel = GetChannelFromParam(getSearchParam("channel"));

  const selectedConversation = useMemo(() => {
    if (!conversations || !selectedUserId) return undefined;
    return conversations[selectedUserId];
  }, [conversations, selectedUserId]);

  let session;
  if (selectedConversation && selectedConversation.sessions?.[channel]) {
    session = selectedConversation.sessions[channel];
  }

  const [tabState, setTabState] = useState<ConversationUserListTabsStateType>(selectedUserId ? ConversationUserListTabsStateType.Loading : ConversationUserListTabsStateType.Open);
  // const sessionDataInitialSessions = useMemo(() => {
  //   if (!sessions) return {};
  //   return Object.values(sessions).reduce((acc, session) => {
  //     if (session?.escalation && Object.values(session.escalation).length > 0) {
  //       acc[session.id] = session;
  //     }
  //     return acc;
  //   }, {} as { [sessionId: number]: SessionInterface });
  // }, [sessions]);

  // const { sessionMessageData, markSessionAsRead } = useSessionMessageData(sessionDataInitialSessions, session?.id);

  useEffect(() => {
    NavBar.set(
      <HeaderAgentView />,
      <NavBar.Component.Title title="Conversations" />,
      <HeaderRightSection />
    );

    UsersModel.loadAll();
    const reloadInterval = setInterval(() => {
      UsersModel.loadAll();
    }, 1000 * 60 * 3); // Reload every 3 minutes
    if (!Member.hasSeenStartShiftModal) {
      ModalModel.showModalWithContent(null, <StartShiftModal />, 544, 544, false);
    }
    UsersOnlineManager.start(); // Start the online manager when entering the view
    return () => {
      clearInterval(reloadInterval);
      UsersOnlineManager.stop(); // Stop the online manager when leaving the view
    }
  }, []);

  const userVars = useMemo(
    () => (selectedUserId && vars ? vars[selectedUserId] : undefined),
    [vars, selectedUserId]
  );

  // set load user, vars, and events for selected user
  useEffect(() => {
    if (selectedUserId) {
      UserVarsModel.loadForUser(selectedUserId);
      UsersModel.loadUsersByIds([selectedUserId]);
    }
    // NotificationsManager.registerForConversationUpdates(selectedUserId);
    if (selectedUserId) {
      SocketEventsManager.setSubscriptionState([
        SocketEventType.AVAILABLE_MEMBERS,
        SocketEventType.SESSION,
        SocketEventType.ESCALATION,
        SocketEventType.VARS,
        SocketEventType.USERS_ONLINE,
        SocketEventType.NOTIFICATION,

      ], selectedUserId); // AdamTodo
    } else {
      SocketEventsManager.setSubscriptionState([
        SocketEventType.AVAILABLE_MEMBERS,
        SocketEventType.SESSION,
        SocketEventType.ESCALATION,
        SocketEventType.USERS_ONLINE,
        SocketEventType.NOTIFICATION,

      ]); // AdamTodo
    }
    return () => {
      // NotificationsManager.unregisterForConversationUpdates();
      SocketEventsManager.setSubscriptionState([SocketEventType.NOTIFICATION]); // AdamTodo set state
    };
  }, [selectedUserId]);

  // default to most recent channel on initial navigation to conversation
  useEffect(() => {
    if (conversations && selectedUserId && conversations[selectedUserId]) {
      const mostRecentChannel = conversations[selectedUserId].lastUserMessageChannel;

      if (mostRecentChannel) {
        setSearchParam("channel", mostRecentChannel);
      }
    }
  }, [selectedUserId]);

  const setTab = (state: ConversationUserListTabsStateType, fromClick?: boolean) => {
    setTabState(state);
    if (fromClick) {
      navigate("/conversations"); // We need to reset the URL to conversation so we can switch tabs.
    }
  }

  // const handleMarkSessionAsRead = (sessionId: number, userId: number) => {
  //   markSessionAsRead(sessionId, userId);
  // };

  return (
    <div className="flex divide-grey-300 bg-white divide-x size-full overflow-hidden">
      <div className="w-1/3 h-full">
        <ConversationUserListColumn
          setTab={setTab}
          tabState={tabState}
          conversations={conversations}
          selectedUserId={selectedUserId}
          // sessionMessageData={sessionMessageData}
          users={users}
        />
      </div>
      <div className="w-1/3 h-full">
        <MultiChannelColumn
          tabState={tabState}
          conversation={selectedConversation}
          selectedUser={selectedUser}
          // handleMarkSessionAsRead={handleMarkSessionAsRead}
          channel={channel}
          session={session}
        // sessionMessageData={sessionMessageData}
        />
      </div>
      <div className="w-1/3 h-full">
        {selectedUser && userVars && <UserDetails user={selectedUser} userVars={userVars} />}
      </div>
    </div>
  )
}

const HeaderRightSection = () => {
  return (
    <div className="flex items-center gap-2">
      <SMSCampaignButton />
      <MembersOnlineSection />
    </div>
  );
}

export default ConversationsView;
